import { useUser } from '@clerk/nextjs';
import { useIsPrescriber } from '@web-app/hooks/useIsPrescriber';
import React, { useMemo } from 'react';

import {
  SessionReminderContext,
  SessionReminderContextValue,
} from './SessionReminderModal';

export const SessionReminderTrackingProvider = ({
  roomId,
  appointmentId,
  children,
}: React.PropsWithChildren<{ roomId: string; appointmentId?: string }>) => {
  const { user, isLoaded } = useUser();
  const { isPrescriber, isLoading, isError } = useIsPrescriber();
  const providerClerkId = user?.id;
  const providerType =
    !isLoaded || !user || isLoading || isError
      ? 'unknown'
      : isPrescriber
        ? 'prescriber'
        : 'mnt';
  const value = useMemo<SessionReminderContextValue>(
    () => ({ roomId, appointmentId, providerClerkId, providerType }),
    [roomId, appointmentId, providerClerkId, providerType],
  );

  return (
    <SessionReminderContext.Provider value={value}>
      {children}
    </SessionReminderContext.Provider>
  );
};
